import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "timi-dashboard-container" }
const _hoisted_2 = { class: "date-slider" }
const _hoisted_3 = { class: "date-slider-current" }
const _hoisted_4 = {
  key: 0,
  class: "info"
}
const _hoisted_5 = {
  class: "row",
  "data-cols": "2"
}
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 1,
  class: "top-action-bar"
}
const _hoisted_9 = {
  key: 0,
  class: "col-4"
}
const _hoisted_10 = { class: "ww-data-list-item" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "--", -1)
const _hoisted_12 = { class: "ww-data-list-item" }
const _hoisted_13 = { class: "ww-data-list-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_DateInput = _resolveComponent("DateInput")!
  const _component_Searchbar = _resolveComponent("Searchbar")!
  const _component_Table = _resolveComponent("Table")!
  const _component_Card = _resolveComponent("Card")!
  const _component_DataList = _resolveComponent("DataList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_IconButton, {
        icon: _ctx.store.getters.svgIcons.arrowbackward,
        class: "",
        onOnClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleSwitchDay(-1)))
      }, null, 8, ["icon"]),
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.dateInputEnabled)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.displayActiveDay), 1))
          : _createCommentVNode("", true),
        (!_ctx.dateInputEnabled)
          ? (_openBlock(), _createBlock(_component_IconButton, {
              key: 1,
              icon: _ctx.store.getters.svgIcons.currentDay,
              onOnClick: _ctx.onSwitchCalendarButton
            }, null, 8, ["icon", "onOnClick"]))
          : _createCommentVNode("", true),
        (_ctx.dateInputEnabled)
          ? (_openBlock(), _createBlock(_component_DateInput, {
              key: 2,
              value: _ctx.formatDateInputValue(_ctx.activeDay),
              onOnChange: _ctx.onDateInputDateChange
            }, null, 8, ["value", "onOnChange"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_IconButton, {
        icon: _ctx.store.getters.svgIcons.arrowforward,
        onOnClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleSwitchDay(1)))
      }, null, 8, ["icon"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Card, {
          title: _ctx.$t('label.dashboardDay')
        }, {
          default: _withCtx(() => [
            (_ctx.dataLoading)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "svgicon svgicon--loader",
                  innerHTML: _ctx.store.getters.svgIcons.loader
                }, null, 8, _hoisted_7))
              : _createCommentVNode("", true),
            (!_ctx.dataLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_Searchbar, {
                    onOnValueChange: _cache[2] || (_cache[2] = (input) => _ctx.searchInput = input)
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.employees.length && !_ctx.dataLoading)
              ? (_openBlock(), _createBlock(_component_Table, {
                  key: 2,
                  class: "header-small",
                  tableData: _ctx.employeeStatisticData,
                  src: _ctx.employeeStatistics,
                  emptyStateText: _ctx.$t('emptyState.employees'),
                  onOnActionClicked: _ctx.handleTableActionClicked
                }, null, 8, ["tableData", "src", "emptyStateText", "onOnActionClicked"]))
              : _createCommentVNode("", true),
            false
              ? (_openBlock(), _createBlock(_component_Table, {
                  key: 3,
                  class: "header-small",
                  tableData: _ctx.employeeTableData,
                  src: _ctx.filteredEmployees,
                  emptyStateText: _ctx.$t('emptyState.employees'),
                  onOnActionClicked: _ctx.handleTableActionClicked
                }, null, 8, ["tableData", "src", "emptyStateText", "onOnActionClicked"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      false
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_Card, {
              title: _ctx.sessionCompany.title
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DataList, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.version')), 1),
                      _hoisted_11
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.usermode')), 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.sessionCompany.userMode), 1)
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('label.user')), 1),
                      _createElementVNode("span", null, _toDisplayString(), 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.sessionUser.username), 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["title"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}